import { matchPath } from 'react-router-dom';

//
//

export function isExternalLink(path: string) {
  return path.includes('http');
}

export function getActive(path: string, pathname: string) {
  return path ? !!matchPath({ path: path, end: false }, pathname) : false;
}

export function hasActiveChild(children: { path: string; children?: any }[] | undefined, pathname: string): boolean {
  if (!children?.length) return false;

  return children.some(
    (child) => getActive(child.path, pathname) || hasActiveChild(child.children, pathname)
  );
}
